import React from 'react';
import './YouthSportsHero.css';

const YouthSportsHero = () => {
  return (
    <section className="youth-sports-hero">
      <div className='youth-sports-hero-overlay'>
        <div className="youth-sports-hero-wrapper">
          <h1 className="youth-sports-hero-title">Youth & Sports Development</h1>
          <p className="youth-sports-hero-subtitle">Empowering the future of our youth through sports and recreation programs.</p>
        </div>
      </div>
    </section>
  );
};

export default YouthSportsHero;